import React from "react";
import "../../Styles/certified/icom.css";

export default function Finzly() {
  return (
    <>
      <div className="icom-certified-details-section">
        <div className="icom-certified-details-title">
          OUTSTANDING WORKPLACES CERTIFIED COMPANIES
        </div>
        <div className="icom-certified-details-container">
          {/* Left: Badge and Company Info side by side */}
          <div className="icom-certified-details-left">
            <img
              src="/june_2026.png"
              alt="Outstanding Workplaces Certified"
              className="icom-certified-badge"
            />
            <div className="icom-certified-company-names">
              <a href="http://www.icommtechnologies.com/" target="_blank" rel="noopener noreferrer">
              <img
                src="/assets/icom/icom.png"
                alt="Walkzero Logo"
                className="icom-certified-company-logo"
              />
            </a>
              <h1 className="icom-certified-full-name">
              Icomm Technologies Private Limited
              </h1>
            </div>
          </div>
          {/* Right: Company Image */}
          <div className="icom-certified-details-right">
            <img
              src="/assets/icom/icom_2.jpg"
              alt="Finzly Office"
              className="icom-certified-company-image"
            />
          </div>
        </div>
        {/* Description section below */}
        <div className="icom-certified-description">
          <h2>
            Why  Icomm Technologies Private Limited is an Outstanding Workplaces
          </h2>
          <p>
            FormulaHR is a leading HRMS, Payroll Software, and Payroll Outsourcing solutions provider based in Chennai. Powered by Icomm Technologies Pvt Ltd, it is an AI-powered, people-centric platform trusted by 6,00,000+ users and 500+ organizations across India, backed by over two decades of expertise.


          </p>
          <p>
            Recognized as one of the most referred HR software solutions, FormulaHR offers a comprehensive suite covering Recruitment & Onboarding, Employee Management, Leave & Attendance, Payroll, Performance Management, Expense Management, Mobile HR, and more.
          </p>
          <p>
            With AI-powered capabilities such as Resume Screening, Smart Goals, and Talent Analytics, along with robust statutory compliance, workforce analytics, and managed payroll services, FormulaHR helps organizations improve efficiency, ensure compliance, and enhance employee experience. As a trusted HR and payroll solutions expert, FormulaHR delivers enterprise-grade technology for businesses of all sizes.
          </p>
          
        </div>
        {/* Info Cards Section */}
        <div className="icom-certified-info-cards">
          <div className="icom-certified-info-card">
            <div className="icom-certified-info-title">COMPANY SIZE</div>
            <div className="icom-certified-info-value">70 Employees</div>
          </div>
          <div className="icom-certified-info-card">
            <div className="icom-certified-info-title">INDUSTRY</div>
            <div className="icom-certified-info-value"> Information Technology & Services 

</div>
          </div>
          <div className="icom-certified-info-card">
            <div className="icom-certified-info-title">CONNECT</div>
            <div className="icom-certified-info-icons">
              <span className="icom-certified-icon-round">
                <a href="http://www.icommtechnologies.com/" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/website.png" alt="Website" />
                </a>
              </span>
              <span className="icom-certified-icon-round">
                <a href="https://www.linkedin.com/company/icomm-technologies/?originalSubdomain=uk" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/linkedin.png" alt="LinkedIn" />
                </a>
              </span>
              <span className="icom-certified-icon-round">
                <a href="https://www.facebook.com/Icommpeople.in/" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/facebook.png" alt="Facebook" />
                </a>
              </span>
            </div>
          </div>
          <div className="icom-certified-info-card">
            <div className="icom-certified-info-title">LOCATION (HQ)</div>
            <div className="icom-certified-info-value">Chennai</div>
          </div>
        </div>
        {/* Recognitions Section */}
        <div className="icom-certified-recognition-section">
          <h2 className="icom-certified-recognition-title">
            Recognitions awarded by Outstanding Workplaces
          </h2>
          <div className="icom-certified-recognition-badge">
            <img
              src="/june_2026.png"
              alt="Outstanding Workplaces Certified"
              className="icom-certified-recognition-image"
            />
          </div>
          <div className="icom-certified-recognition-label">
            Outstanding Workplaces - Certified
          </div>
        </div>
        {/* Life at Finzly Section */}
        <div className="icom-certified-life-section">
          <h2 className="icom-certified-life-title">
            Life at Icomm Technologies Private Limited
          </h2>
          <div className="icom-certified-life-gallery">
            <div className="icom-certified-life-col">
              <img src="/assets/icom/icom_1.jpg" alt="Office 1" className="icom-certified-life-img" />
              <img src="/assets/icom/icom_2.jpg" alt="Team 1" className="icom-certified-life-img" />
            </div>
            <div className="icom-certified-life-col icom-certified-life-center">
              <img src="/assets/icom/icom_5.png" alt="Main Office" className="icom-certified-life-img icom-certified-life-img-large" />
            </div>
            <div className="icom-certified-life-col">
              <img src="/assets/icom/icom_3.jpg" alt="Office 2" className="icom-certified-life-img" />
              <img src="/assets/icom/icom_4.jpg" alt="Team 2" className="icom-certified-life-img" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
